import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidateNotifications } from "web_myplann/Api/Notifications/notificatioKeys";
import { markChatConversationRead } from "web_myplann/Chat/Helpers/List/markChatConversationRead";
import {
	type MarkReadResponseDTO,
	patchChatsConversationsIdReadV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";
import { logWarning } from "web_myplann/Infrastructure/sentry";
import { device } from "web_myplann/Utils/device";

type SetReadMessageVariables = {
	conversationId: number;
	messageId: number;
};

const setReadMessage = processResponse(
	({ conversationId, messageId }: SetReadMessageVariables) =>
		patchChatsConversationsIdReadV2({ messageId }, conversationId),
	{ skipToastFor: true },
);

export const useSetReadMessageMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (
			variables: SetReadMessageVariables,
		): Promise<MarkReadResponseDTO | undefined> => setReadMessage(variables),
		onSuccess: (response, variables) => {
			if (!response) return;

			markChatConversationRead(
				queryClient,
				variables.conversationId,
				response.unreadCount,
			);
			invalidateNotifications(queryClient);

			device
				.setChatUnreadCount(response.chatNotReadCount)
				.catch(() => logWarning("Failed to send chat unread count to app"));
		},
	});
};
